import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Breadcrumb, Spin, Divider, Button, Pagination, Icon } from 'antd';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { Document, Page } from 'react-pdf';
import moment from 'moment';
import styled from 'styled-components';

import { getId, getUrlExtension } from '../../utils/params';
import { getDetailArticle } from '../../actions';

const FeaturedImage = styled.div`
  overflow: hidden;
  background-size: cover;
  background-position: center;
  height: 220px;
  margin-top: 10px;
  background-color: #364d79;
  background-image: url(${props => props.src});
`;

class Article extends Component {
  state = {
    numPages: 0,
    pageNumber: 1,
  }

  componentDidMount() {
    this.getDetail(this.props.match.params.code);
  }

  componentWillReceiveProps(nextProps) {
    const { match: { params: { code } } } = this.props;
    if (nextProps.match.params.code !== code) {
      this.getDetail(nextProps.match.params.code);
    }
  }

  onDocumentLoad = ({ numPages }) => {
    this.setState({ numPages });
  }

  getDetail = code => {
    const id = getId(code);
    this.props.getDetailArticle(id);
  }

  renderAttachments = (attachments) => attachments.map((attachment, idx) => {
    const ext = getUrlExtension(attachment.url);
    const fileurl = window.location.origin+attachment.url;
    return (
      <div key={attachment._id} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Divider />
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
          <p>Tệp đính kèm [{idx + 1}]:</p>
           {(ext === 'docx' || ext === 'doc' || ext === 'xlsx' || ext === 'xls' || ext === 'pptx' || ext === 'ppt') && (
            <h3><a href={'https://view.officeapps.live.com//op/view.aspx?src='+fileurl}>{attachment.name}</a></h3>
           )}
           {ext === 'pdf' && (
            <h3><a href={'https://docs.google.com/gview?url='+fileurl}>{attachment.name}</a></h3>
           )}          
          <Button><a href={attachment.url} target='_blank'><Icon type="download" /></a></Button>
        </div>
        {ext === 'pdf' && (
          <Fragment>
            <Document
              file={attachment.url}
              onLoadSuccess={this.onDocumentLoad}
              loading={<Spin />}
            >
              <Page pageNumber={this.state.pageNumber} />
            </Document>
            <Pagination
              size='small'
              defaultPageSize={1}
              total={this.state.numPages}
              current={this.state.pageNumber}
              onChange={page => this.setState({ pageNumber: page })}
            />
          </Fragment>
        )}
        {(ext === 'jpg' || ext === 'png' || ext === 'jpeg') && (
          <img src={attachment.url} style={{ width: 400, height: 400, objectFit: 'contain' }} />
        )}
        {(ext === 'docx' || ext === 'doc' || ext === 'xlsx' || ext === 'xls' || ext === 'pptx' || ext === 'ppt') && (
          <iframe width="100%" height="600" frameBorder="0" src={'https://view.officeapps.live.com/op/embed.aspx?src='+fileurl} />
        )}
      </div>
    );
  });

  render() {
    const { article: { detail, detailLoading }, match } = this.props;

    if (!detail || detailLoading) {
      return <Spin />;
    }

    return (
      <div>
        <Breadcrumb style={{ margin: '5px 0' }}>
          <Breadcrumb.Item><Link to='/'>Trang chủ</Link></Breadcrumb.Item>
          {detail.category
            && <Breadcrumb.Item><Link to={`/danh-muc/${detail.category.name}-${detail.category._id}`}>{detail.category.name}</Link></Breadcrumb.Item>}
          <Breadcrumb.Item><Link to={`/bai-viet/${match.params.code}`}>{detail.title}</Link></Breadcrumb.Item>
        </Breadcrumb>
        {/* {detail.featuredImage && <FeaturedImage src={detail.featuredImage} />} */}
        <h2 style={{ marginTop: 10 }}>{detail.title}</h2>
        <p style={{ color: 'grey' }} >{moment(detail.createdAt).format('Do MMMM YYYY, h:mm')}</p>
        <Divider />
        {ReactHtmlParser(detail.content)}
        {detail.attachments.length > 0 && this.renderAttachments(detail.attachments)}
      </div>
    );
  }
}

export default connect(state => ({
  article: state.article,
}), {
  getDetailArticle,
})(Article);



// WEBPACK FOOTER //
// ./src/screens/Article/Article.js